import { MentorshipStatusValues } from 'enums/MentorshipStatus';

export const mentorshipTags: MentorshipStatusValues[] = [
  'WAITING_MENTOR',
  'WAITING_MENTEE',
  'REFUSED_MENTOR',
  'REFUSED_MENTEE',
  'FIRST_INTERVIEW',
  'LATE_MENTEE_FIRST_INTERVIEW',
  'LATE_MENTOR_FIRST_INTERVIEW',
  'ONGOING',
  'LATE_MENTOR',
  'LATE_MENTEE',
  'INTERRUPTION_REQUEST_MENTEE',
  'INTERRUPTION_REQUEST_MENTOR',
  'INTERRUPTED_ADMIN',
  'FINISHED_ADMIN',
  'FINISHED_DATE',
];

export const getTempUpdateAllowedMentorshipStatus = (
  currentStatus: MentorshipStatusValues,
): MentorshipStatusValues[] => {
  switch (currentStatus) {
    case 'WAITING_MENTEE':
    case 'WAITING_MENTOR':
    case 'FIRST_INTERVIEW':
    case 'LATE_MENTEE_FIRST_INTERVIEW':
    case 'LATE_MENTOR_FIRST_INTERVIEW':
    case 'ONGOING':
    case 'LATE_MENTEE':
    case 'LATE_MENTOR':
    case 'INTERRUPTION_REQUEST_MENTEE':
    case 'INTERRUPTION_REQUEST_MENTOR':
      return [
        'WAITING_MENTOR',
        'REFUSED_MENTOR',
        'WAITING_MENTEE',
        'REFUSED_MENTEE',
        'FIRST_INTERVIEW',
        'LATE_MENTEE_FIRST_INTERVIEW',
        'LATE_MENTOR_FIRST_INTERVIEW',
        'ONGOING',
        'LATE_MENTEE',
        'LATE_MENTOR',
        'INTERRUPTION_REQUEST_MENTEE',
        'INTERRUPTION_REQUEST_MENTOR',
      ];
    default:
      return [];
  }
};

export const historyTags: MentorshipStatusValues[] = [
  'REFUSED_MENTEE',
  'REFUSED_MENTOR',
  'INTERRUPTED_ADMIN',
  'FINISHED_ADMIN',
  'FINISHED_DATE',
];

export const ongoingTags: MentorshipStatusValues[] = [
  'WAITING_MENTEE',
  'WAITING_MENTOR',
  'FIRST_INTERVIEW',
  'LATE_MENTEE_FIRST_INTERVIEW',
  'LATE_MENTOR_FIRST_INTERVIEW',
  'ONGOING',
  'LATE_MENTEE',
  'LATE_MENTOR',
  'INTERRUPTION_REQUEST_MENTEE',
  'INTERRUPTION_REQUEST_MENTOR',
];
